import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MatchTabs = ({ selectedTab, onSelectTab, isReview , iShowLead = false }) => {
  let tabs = [
    { name: "User Profile", current: selectedTab === "User Profile" },
  ];
  if (isReview) {
    tabs.push({ name: "Review", current: selectedTab === "Review" });
  }
  if(iShowLead)
  {
    tabs = [...tabs,{ name: "Leads", current: selectedTab === "Leads" }]
  }
  return (
    <div>
      <div className="block">
        <nav className={`grid ${iShowLead ? "grid-cols-3" : "grid-cols-2" }`} aria-label="Tabs">
          {tabs.map((tab, tabIdx) => (
            <button
              key={tab.name}
              onClick={() => onSelectTab(tab.name)}
              className={classNames(
                tab.current
                  ? "bg-primary text-white"
                  : " bg-[#EBEFF3] text-[#485868]",
                tabIdx === 0 ? "rounded-tl-md" : "",
                tabIdx === tabs.length - 1 ? "rounded-tr-md" : "",
                "group overflow-hidden h-[42px] flex items-center justify-center text-center text-sm font-bold leading-[160%]"
              )}
              aria-current={tab.current ? "page" : undefined}
            >
              <span>{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
export default MatchTabs;
